module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-144x144-68aabf07826314524f7c80210019b5ae.png";